module.exports = __webpack_public_path__ + "static/media/bgr_img.f34b27af.jpg";